import { render, staticRenderFns } from "./ClientCertificateNew.vue?vue&type=template&id=b72f4434&"
import script from "./ClientCertificateNew.vue?vue&type=script&lang=js&"
export * from "./ClientCertificateNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports